import React, {useImperativeHandle, useState, useRef, forwardRef, useEffect} from "react";

import {View, Text, TextInput}  from 'react-native';

import {estilos} from '../util/estilos'

import Botao from '../componentes/Botao'

import cores from '../util/cores'

import {carregamento} from '../componentes/Carregamento'

import * as util from '../util/util'

import {semDados} from '../componentes/SemDados'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

let pagina = 0;
	

const FormularioPesquisa = forwardRef((props, ref) => {

	const [termos, setTermos] = useState(null)
	const [lista, setLista] = useState([])
	const [msg, setMsg] = useState(props.msgSemDados)
	const [sincronizando, setSincronizando] = useState(false)
	
	const btPesquisarRef  = useRef(null)
	
	
	useEffect(() => {pagina=0}, []);

	useImperativeHandle(ref, () => ({
		pesquisar: () => pesquisar(),
		sincronizando: () => prepararParaPesquisar(),
		getIndex: () =>{return pagina;}
	}));
	
	
	const pesquisar= async ()=>{

		util.print("FormularioPesquisa pesquisar")

		prepararParaPesquisar()
		
		setLista(await props.pesquisar(termos));

		if(btPesquisarRef.current)
			btPesquisarRef.current.setCarregando(false)
		
		setSincronizando(false)
	}


	const prepararParaPesquisar= ()=>{
		
		setSincronizando(true)

		if(btPesquisarRef.current)
			btPesquisarRef.current.setCarregando(true)	
	}
	
	
	return (
		<View style={{flex: 1}}>
			<Scroll>  
			<Bloco podeRecolher={true}>  
				<View style={{marginTop:10}}/>   
				<Text style={estilos.rotulo_padrao}>Buscar:</Text>
				<TextInput
					placeholder="Informe..."
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>setTermos(text)}
					maxLength={150}
					value={termos}/>
				
				{props.componentes}
				
				<View style={{alignItems:'center'}}>
					<Botao
						acao={()=>{
							pagina=0; 
							setMsg(props.msgSemDados);
							pesquisar()}}
						texto="Pesquisar"
						cor={cores.azul}
						ref={btPesquisarRef}/>   
				</View>
			</Bloco>
				{(sincronizando) ?
					(carregamento(sincronizando)):
					(<View style={{flex:1}}>
						{props.children}
						{util.temConteudo(lista)?
							
							
								(lista.map((item, index) => {
									return (
										<View key={index}>
											
											{props.itemLista(item)}
										
											{(index == (lista.length-1)) &&  
												<View style={{alignItems:'center'}}>
													<View style={{marginTop:30}}/>	
													<Botao
														acao={()=>{
															pagina +=1; 
															setMsg("Não há mais resultados");
															pesquisar()}
														}
														texto="Carregar Mais Resultados"
														cor={cores.azul}/> 
													<View style={{marginTop:30}}/>	
												</View>
											}
										</View>)
								}))
							:
							<Bloco todaArea={true}> 
								{semDados("info", msg, 60)}
							</Bloco>
						}
					</View>)
				}
			</Scroll> 	
		</View> 
	);
});

export default FormularioPesquisa;
